import React from 'react';
import { observer } from 'mobx-react';

import AddCommentActivities from 'ui/AddCommentActivities';

import { useStore } from 'utils/hooks/store';

import AlarmActivitiesStore from 'stores/AlarmDetails/AlarmActivities';

const AlarmActivities: React.FunctionComponent = (): React.ReactElement => {
  const { alarmDetails } = useStore();
  const activities = alarmDetails.activities as AlarmActivitiesStore;

  return (
    <AddCommentActivities
      placeholder="Add a comment or drag and drop files"
      uploadFile={activities.uploadFile}
      sendMessage={activities.addMessage}
    />
  );
};

export default observer(AlarmActivities);
